// extracted by mini-css-extract-plugin
module.exports = {"hintText":"HintText_hintText__wgg_U"};